import React from 'react';
import { useSelector } from 'react-redux';
import Button from 'react-bootstrap/Button';
import { getUserName } from '@redux/selectors/UserSelector';

import cloudCMAIcon from '@images/logos/vendor/cloudCMA-logo.svg';
import GAEventTracking from '@components/tracking/GAEventTracking';

const CloudCMAWidget = () => {
  const gaEventTracker = GAEventTracking('User');
  const username = useSelector(getUserName);

  return (
    <div className="panel-content text-center rounded" style={{ backgroundColor: '#fff', minHeight: '231px' }}>
      <img alt="CloudCMA-icon" src={cloudCMAIcon} className="img-fluid mb-4" style={{ height: '40px' }} />
      <p className="mb-5" style={{ color: 'var(--darkBackground-4)' }}>
        <strong>Cloud CMA </strong>
        is a tool to helps you build better Comparative Market Analysis reports and interactive presentations that win more listings.
      </p>
      <Button
        onClick={() => {
          window.open('https://cloudcma.com/real-estate-agents', '_blank');
          gaEventTracker('Opened CloudCMA', `${username}`);
        }}
        variant="primary"
      >
        <i className="far fa-external-link mr-2" />
        Cloud CMA
      </Button>
    </div>
  );
};

export default CloudCMAWidget;
